// Single source of truth for affiliate providers.
// Used by:
//  - ExperienceCard.js   → renders the per-provider CTA button
//  - AffiliateSection.jsx → populates the admin form's provider <select>

export const AFFILIATE_PROVIDERS = {
  getyourguide: {
    name: 'GetYourGuide',
    bg: '#FF5621',
    hoverBg: '#CC3F12',
    logo: 'https://customer-assets.emergentagent.com/job_explore-experiences-1/artifacts/oz79cb0t_GYGLOGO.webp',
    logoClass: 'h-4',
  },
  viator: {
    name: 'Viator',
    bg: '#008767',
    hoverBg: '#006B52',
    logo: 'https://customer-assets.emergentagent.com/job_explore-experiences-1/artifacts/bqawbtjl_VLOGO.webp',
    logoClass: 'h-4 -mt-[1px]',
  },
  tiqets: {
    name: 'Tiqets',
    bg: '#18babd',
    hoverBg: '#149da0',
    logo: '/logos/tiqets.webp',
    logoClass: 'h-4 scale-[1.3]',
  },
  gocity: {
    name: 'GoCity',
    bg: '#28939c',
    hoverBg: '#217b83',
    logo: '/logos/gocity.webp',
    logoClass: 'h-4',
  },
};

// Fallback used when a stored experience has an unknown provider slug.
export const DEFAULT_PROVIDER_KEY = 'getyourguide';

export function getProvider(key) {
  return AFFILIATE_PROVIDERS[key] || AFFILIATE_PROVIDERS[DEFAULT_PROVIDER_KEY];
}
